export default __webpack_public_path__ + "static/eduardo-san-martin-morote-f8d50ad86fee4a8d468102e989df9ca2.jpg";